import { gql, useMutation } from '@apollo/client';

import type {
  UpdateDependentContactMutation,
  UpdateDependentContactMutationVariables,
} from './__generated__/useUpdateDependentContact.gql';

const UPDATE_DEPENDENT_CONTACT = gql`
  mutation UpdateDependentContact($input: UpdateDependantInput!) {
    updateDependant(input: $input) {
      id
      email
      phoneNumber
    }
  }
`;

/**
 * Edit a dependent's email + phone columns. Distinct from
 * `useUpdateDependent` (which projects the firstName / lastName / dob
 * fields used by `DependentEntryStep`) — both call the same backend
 * `updateDependant` mutation, but each hook returns the projection its
 * consumer cares about. Apollo merges the response into the existing
 * `Dependant:<id>` cache record, so `useDependents` consumers
 * pick up the new contact values automatically.
 *
 * @returns The standard `useMutation` tuple — `[mutate, MutationResult]`
 *   where `MutationResult.loading` / `.error` / `.data` track the
 *   in-flight call.
 */
export const useUpdateDependentContact = () => {
  return useMutation<UpdateDependentContactMutation, UpdateDependentContactMutationVariables>(UPDATE_DEPENDENT_CONTACT);
};
